'use client';
import { __rest } from 'tslib';
import React, { Fragment } from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import Trigger from './components/Trigger.js';
import Item, { ItemButton } from './components/Item.js';
import { styled } from '../../stitches.config.js';
import Content from './components/Content.js';
import '../../utils/radixColors.js';
import { isStringArray } from '../../utils/utils.js';
import 'date-fns';
import 'lodash';

const SelectGroupEl = styled(SelectPrimitive.Group, {});
const Separator = styled(SelectPrimitive.Separator, {
    height: 1,
    backgroundColor: '$gray6',
    margin: 5,
});
const GroupLabel = styled(SelectPrimitive.Label, {
    padding: '0 25px',
    fontSize: 12,
    lineHeight: '25px',
    color: '$gray11',
});
function handleType(obj) {
    if (Array.isArray(obj)) {
        return React.createElement(React.Fragment, null, obj.map(x => handleType(x)));
    }
    switch (obj.type) {
        case 'group':
            return (React.createElement(Fragment, { key: 'group_' + obj.label },
                React.createElement(Separator, null),
                React.createElement(SelectGroupEl, null,
                    React.createElement(GroupLabel, null, obj.label),
                    handleType(obj.items))));
        case 'item':
            return React.createElement(Item, { key: obj.value, value: obj.value }, obj.label);
        default:
            return React.createElement(ItemButton, { key: 'button_' + obj.label, handleClick: obj.handleClick }, obj.label);
    }
}
/**
 * should i nest a form in here?
 * @returns
 */
const Select = React.forwardRef((_a, forwardedRef) => {
    var { placeholder = 'Select a category', data, value, onChange, error, allowSelectNone = false, noneValue = '/', color } = _a, props = __rest(_a, ["placeholder", "data", "value", "onChange", "error", "allowSelectNone", "noneValue", "color"]);
    const noCategoryItem = {
        type: 'item',
        label: placeholder,
        value: noneValue,
    };
    if (isStringArray(data))
        data = data.map(item => ({ value: item, label: item, type: 'item' }));
    data = allowSelectNone ? [noCategoryItem, ...data] : [...data];
    return (React.createElement(SelectPrimitive.Root, Object.assign({ ref: forwardedRef }, props, { value: value, onValueChange: onChange }),
        React.createElement(Trigger, { color: color, error: error, placeholder: placeholder }),
        React.createElement(Content, null,
            React.createElement(React.Fragment, null, handleType(data)))));
});

export { Select };
